import exEventCreate from './create';
import exTrigger from './trigger';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        addEvent(config: Record<string, any>): HTMLElement;
        trigger(type: string, config?: CustomEventInit): HTMLElement;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.addEvent = function (config: Record<string, any>): HTMLElement {
    exEventCreate(this, config);

    return this;
};

HTMLElement.prototype.trigger = function (type: string, config: CustomEventInit = {}): HTMLElement {
    exTrigger(this, type, config);

    return this;
};
